/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-useless-constructor */
import React, { Component } from 'react';
import Chart from 'react-apexcharts';


import {
  Card as CardUI,
  CardHeader,
  CardContent,
  Grid,
  Box,
  List,
  ListItem,
  ListItemText,
  Button,
  InputLabel,
  Paper,
} from '@material-ui/core';

import { parseISO, format } from 'date-fns';

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import { Autorenew } from '@material-ui/icons';
import moment from 'moment';
import PropTypes from 'prop-types';

import Slider from '@material-ui/core/Slider';

import { t, number } from '~/helpers';

import { Container } from './styles';

import VLIPlus from '~/assets/images/TanqueFisico.jpg';

const styles = {
  title: {
    color: '#7b7b7b',
  },
  rootContent: {
    padding: '0px',
    '&:last-child': {
      paddingBottom: '0px',
    },
  },
  gutters: {
    paddingLeft: '0px',
    paddingRight: '16px',
  },
  secondaryNegative: {
    color: '#b73c3c !important',
  },
  secondaryPositive: {
    color: '#2d7d2d !important',
  },
  alterar: {
    color: '#4caf50',
    margin: '2rem',
  },
};



const EditSlider = withStyles({
  root: {
    color: '#a0f75f',
    height: 8,
    marginLeft: 3,
  },
  thumb: {
    height: 18,
    width: 18,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    display: 'none',
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);
export { EditSlider }

const EditSlider2 = withStyles({
  root: {
    color: 'red',
    height: 8,
    marginLeft: 3,
  },
  thumb: {
    height: 10,
    width: 10,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    display: 'none',
    borderRadius: 4,
  },
})(Slider);
export { EditSlider2 }

function valuetext(value) {
  return `${number(value, 1)}°C`;
}


class Card extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          width: '100%',
        },
        tooltip: { enabled: false },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: 0,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        yaxis: {
          show: false,
        },
        xaxis: {
          categories: [''],
        },
        legend: {
          position: 'bottom',
          offsetX: 0,
          offsetY: 0,
          horizontalAlign: 'left',
        },
        fill: {
          opacity: 1,
        },
      },
    };

  }



  handleRenderInfoTanque = () => {
    const { station } = this.props
    if ((typeof station.staAlturaProduto) == 'number') {
      return (<>
        <Typography color="colorInherit" variant="h6" > {number(station.taco_vol_corrente_prod, 0)} </Typography>
        <Typography color="colorInherit" variant="h7" > {number(station.staAlturaProduto, 1)} cm </Typography>
      </>)

    } else {
      return (<>
        <Typography color="colorInherit" variant="h6" > {number(station.taco_vol_corrente_prod, 0)} </Typography>
        <Typography color="colorInherit" variant="h7" > {station.staAlturaProduto} cm </Typography>
      </>)
    }
  }

  handleRenderStatus = () => {
    const { station } = this.props
    if (station.st_transmissao == 'ERRO') {
      return (<Typography color="secondary" variant="h6" >Sem Conexão</Typography>)

    } else {

      if (station.taco_modo_leitura == 'M') {
        return (<Typography color="secondary" variant="h6" > {station.taco_modo_leitura_str} </Typography>)
      } else {
        return (<Typography color="primary" variant="h6" > {station.taco_modo_leitura_str} </Typography>)
      }
    }
  }



  render() {

    const { station, refreshProduct, classes } = this.props;
    const { options } = this.state;

    const estoque = parseFloat(
      (station.saldo * 100) / station.capacidade
    ).toFixed(2);
    const vazio = parseFloat(
      (station.espacoVazio * 100) / station.capacidade
    ).toFixed(2);



    const marks = [
      {
        value: 20,
        label: station.taco_temp_01 + '°C',
      },
      {
        value: 40,
        label: station.taco_temp_02 + '°C',
      },
      {
        value: 60,
        label: station.taco_temp_03 + '°C',
      },
      {
        value: 80,
        label: station.taco_temp_04 + '°C',
      },
      {
        value: 100,
        label: station.taco_temp_05 + '°C',
      },
    ];

    const handleShowLabel = (val) => {
      const objt = marks.find((item) => item.value == val)
      if (objt) {
        return objt.label
      }

      return '0'

    }

    return (
      //<Grid item md={4} sm={12}>

      <CardUI >



        <CardContent classes={{ root: classes.rootContent }} style={{ overflowX: 'auto', width: '100%' }}>
          <Box component="div" display="flex" style={{ position: 'relative', margin: '0 2px', width: '470px', height: '275px', backgroundImage: `url(${VLIPlus})`, backgroundRepeat: 'no-repeat', overflow: 'hidden' }}>
            {/* <div display="flex" style={{ display: 'inline-grid' }}> */}
            <Container>
              {/* <label style={{top: '10%'}} >{station.tafi_cod_tafi} </label> */}

              <Typography color="colorInherit" variant="h6" > {station.tafi_cod_tafi} </Typography>
              <Typography color="colorInherit" variant="h7" > DIESEL </Typography>

              {this.handleRenderStatus()}

              <div className="Container__dados_tanque_int">
                {this.handleRenderInfoTanque()}
              </div>

              <div className="Container__cabecalho_dados">
                <Typography color="colorInherit" variant="h6" > Última Medição </Typography>
              </div>


              <div className="Container__body_dados">
                <Typography color="colorInherit" variant="h8" > Data Medição </Typography>
                <Typography color={station.st_transmissao == 'ERRO' ? 'secondary' : 'colorInherit'} variant="h8" > {format(parseISO(station.taco_data_hora_atu), 'dd/MM/yyyy')} </Typography>
                <Typography color={station.st_transmissao == 'ERRO' ? 'secondary' : 'colorInherit'} variant="h8" > {format(parseISO(station.taco_data_hora_atu), 'HH:mm:ss')} </Typography>

                <Typography color="colorInherit" variant="h8" > Temperatura </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.taco_temp_avg, 1)} </Typography>
                <Typography color="colorInherit" variant="h8" > -- </Typography>

                <Typography color="colorInherit" variant="h8" > Volume Ambiente </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.taco_vol_corrente_prod, 0)} </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.percvolcorrente, 2)}% </Typography>

                <Typography color="colorInherit" variant="h8" > Volume 20 </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.taco_vol_corrente_20, 0)} </Typography>
                <Typography color="colorInherit" variant="h8" > -- </Typography>

                <Typography color="colorInherit" variant="h8" > Agua </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.taco_vol_corrente_agua, 0)} </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.percvolagua, 2)}% </Typography>

                <Typography color="colorInherit" variant="h8" > Volume Total </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.volume_total_geral, 0)} </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.percvolume_total_geral, 2)}% </Typography>

                <Typography color="colorInherit" variant="h8" > Capacidade Total </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.taco_capacidade_total, 0)} </Typography>
                <Typography color="colorInherit" variant="h8" > -- </Typography>

                <Typography color="colorInherit" variant="h8" > Capacidade Seg </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.taco_capacidade_seg, 0)} </Typography>
                <Typography color="colorInherit" variant="h8" > {number(station.taco_per_capa_seg, 2)}% </Typography>

                <Typography color="colorInherit" variant="h8" > Espaço Vazio </Typography>
                <Typography color="secondary" variant="h8" > {number(station.taco_espaco_vazio, 0)} </Typography>
                <Typography color="secondary" variant="h8" > {number(station.percespvazio, 2)}% </Typography>

              </div>

              <div className="Container__footer_dados">
                {/* {station.taco_status_abast_anda == 'S' && station.st_transmissao == 'ERRO' ?
                  <Typography color="secondary" variant="h6" className="abastec"> Abastecimento</Typography> :
                  <Typography color="secondary" variant="h6"> Abastecimento</Typography>} */}


                {station.taco_status_abast_anda === 'S' && station.st_transmissao === 'OK' ?
                  <Typography color="secondary" variant="h6" className="abastec" > Abastecimento</Typography> :
                  station.taco_status_alinhamento === '1' ?
                    <Typography color="secondary" variant="h6" > Abastecimento</Typography> :
                    <Typography color="colorInherit" variant="h6" >  </Typography>
                }

                {station.taco_status_rec_anda === '1' && station.st_transmissao === 'OK' ?
                  <Typography color="secondary" variant="h6" className="receb" > Recebimento</Typography> :
                  <Typography color="colorInherit" variant="h6" > </Typography>
                }
              </div>

              <div className="Container__barra_progresso_dados">
                <div className="tnqBar">
                  <EditSlider
                    color="secondary"
                    orientation="vertical"
                    value={station.percvolcorrente}
                    defaultValue={station.percvolcorrente}
                    aria-labelledby="vertical-slider"
                    //getAriaValueText={valuetext}
                    valueLabelDisplay="auto"
                    step={1}
                     //marks={marks}
                    //max={station.percvolume_total_geral}
                    max={100}
                  //disabled
                  />
                </div>
                <div className="tempBar">
                  <EditSlider2
                    color="secondary"
                    orientation="vertical"
                    // value={station.percvolcorrente - 50.00}
                    defaultValue={[20, 40, 60, 80, 100]}
                    aria-labelledby="discrete-slider-always"
                    //getAriaValueText={valuetext}
                    valueLabelDisplay="auto"
                    valueLabelFormat={handleShowLabel}
                    track={false}
                    step={20}
                    marks={marks}
                    max={100}
                    disabled
                  />
                </div>

              </div>





            </Container>

            {/* </div> */}
            {/* <label style={{ top: '10%', left: '40%', position: 'absolute' }} >{station.tafi_cod_tafi} </label> */}
            {/* <input type="text" id="User" name="Name" value=${station.tafi_cod_tafi} /> */}

          </Box>
        </CardContent>

      </CardUI>

    );
    this.handleChangeClass()
  }

}

Card.propTypes = {
  refreshProduct: PropTypes.func.isRequired,
  station: PropTypes.objectOf(PropTypes.any).isRequired,
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(styles)(Card);
